// extracted by mini-css-extract-plugin
export default {"lockButton":"LockButton_lockButton__9T+Yt"};